export default `Region,2018
Seoul,9673936
Busan,3395278
Daegu,2444412
Incheon,2936117
Gwangju,1490092
Daejeon,1511214
Ulsan,1150116
Sejong,312374
Gyeonggi-do,13103188
Gangwon-do,1520391
Chungcheongbuk-do,1620935
Chungcheongnam-do,2181416
Jeollabuk-do,1818157
Jeollanam-do,1790352
Gyeongsangbuk-do,2672902
Gyeongsangnam-do,3350350
Jeju,658282`